const IconHouse = () => (
    <svg width="54" height="41" viewBox="0 0 54 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M54 15.1544L27 0L0 15.1544V17.4867V19.1791V41H54V19.1791V17.4867V15.1544ZM3.14433 27.2697V22.5433C3.14433 20.7786 4.57732 19.3442 6.34021 19.3442C8.10309 19.3442 9.53608 20.7786 9.53608 22.5433V27.2697H3.14433V27.2697Z"
            fill="currentColor"
        />
    </svg>
);

export default IconHouse;
